
export class SlackService {

	static readonly CHANNEL_NEW_COMPANY_FOR_PARITY = 'B09NH3M9KMW/2Gg68laKFs6AwWULKbHHOJH7';
	static readonly CHANNEL_REVHERO_REGISTRATION = 'B0AHEPNA3T3/jykFpTVlhSKZSZBPFcrahXoI';

	public static send = (channel: string, message: string) => {
		return fetch('https://hooks.slack.com/services/T02HCEAR6UA/' + channel, {
			method: 'POST',
			body: JSON.stringify({
				text: message,
			}),
		});
	}
}